import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { CreditCardType } from '../../../../payment/domain/models';
import { IMicroform } from '../../../../shared/api/cybersource/createFlexMicroform';

export interface IPaymentContext {
	newCard: boolean;
	setNewCard: Dispatch<SetStateAction<boolean>>;
	newCardType?: CreditCardType;
	setNewCardType: Dispatch<SetStateAction<CreditCardType | undefined>>;
	isNewCardCVVValid?: boolean;
	setIsNewCardCVVValid: Dispatch<SetStateAction<boolean | undefined>>;
	isNewCardNumberValid?: boolean;
	setIsNewCardNumberValid: Dispatch<SetStateAction<boolean | undefined>>;
	setMicroformInstance: Dispatch<SetStateAction<IMicroform | undefined>>;
	microformInstance?: IMicroform;
	storeCard?: boolean;
	setStoreCard?: Dispatch<SetStateAction<boolean>>;
}

export const PaymentContext = createContext<IPaymentContext>({
	newCard: false,
	/* eslint-disable @typescript-eslint/no-empty-function */
	setNewCard: () => {},
	newCardType: undefined,
	setNewCardType: () => {},
	isNewCardCVVValid: false,
	setIsNewCardCVVValid: () => {},
	isNewCardNumberValid: false,
	setIsNewCardNumberValid: () => {},
	microformInstance: undefined,
	setMicroformInstance: () => {},
	storeCard: false,
	setStoreCard: () => {},
	/* eslint-enable @typescript-eslint/no-empty-function */
});

export const PaymentContextProvider = PaymentContext.Provider;

export const usePaymentContext = () => useContext(PaymentContext);
